<template>
  <section id="testimonials">
    <div class="container">
      <div class="section-header">
        <h2>Testimonials</h2>
      </div>

      <carousel
        :nav="false"
        :dots="false"
        :items="1"
        :autoplay="true"
        :loop="true"
        id="intro-carousel"
        style="margin-top:-50px"
        :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
        class="mt-3"
      >
        <div class="row">
          <div class="col-lg-6">
            <div>
              <img src="img/testimonial-1.png" alt="" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="content">
              <div class="row">
                <div align="center" class="col">
                  <br /><img style="width: 85px" src="img/quote.png" alt="" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    Loved my stay at Crystal Springs. Appreciated the proffesionalism and
                    friendliness of the staff. Thoroughly enjoyed the hike, game drive, jaccuzzi,
                    heated pool, steam room and even the trampolines. Our chalet was in stellar
                    condition. The heaters, extra blankets and fire place ensured we kept warm and
                    toasty during the cold evenings. The food at the restaurant was delicious, and
                    the experience was made even better by the friendly waitress who served us.
                    Arriving to find Ferreiro Roche and Champagne in our chalet was the cherry on
                    top. I would wholeheartedly recommend this resort any day. Well done Crystal
                    Springs!
                  </p>
                  <h5>Anati Bacela</h5>
                  <p>- on visiting Crystal Springs</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div>
              <img src="img/testimonial-2.png" alt="" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="content">
              <div class="row">
                <div align="center" class="col">
                  <br /><img style="width: 85px" src="img/quote.png" alt="" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    We have been going to Ngwenya for 25 years or more. every year we have had
                    wonderful sightings from our verandah. To me it is paradise on earth and we
                    never grow tired of it. Wonderful play area for people of all ages, the gardens
                    are well kept, the restaurant is good and the chalets are well maintained. Most
                    of all what I love about Ngwenya is it's peaceful and tranquil atmosphere and
                    the close proximity to our amazing wild life We will continue going for many
                    more years
                  </p>
                  <h5>Linda Lewis</h5>
                  <p>- on visiting Ngwenya Lodge</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div>
              <img src="img/testimonial-3.2.jpg" alt="" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="content">
              <div class="row">
                <div align="center" class="col">
                  <br /><img style="width: 85px" src="img/quote.png" alt="" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    Great experience, I loved the place, so amazing and we saw many more animals.
                    Had different kinds of visitors everyday (Impala, wild pig, monkeys, birds and
                    more). The nature was great with all mountains and valleys and lakes. Every
                    corner had a new moment. The staff was very friendly and helpful at all times.
                    Thanks to the restaurant staff for helping me organizing my Husband's birthday
                    surprise dinner. Best memories ever. Looking forward to my next visit with
                    friends and more family members.
                  </p>
                  <h5>Sophie Adewale</h5>
                  <p>- on visiting Mabalingwe Nature Reserve</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div>
              <img src="img/testimonial-4.png" alt="" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="content">
              <div class="row">
                <div align="center" class="col">
                  <br /><img style="width: 85px" src="img/quote.png" alt="" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    Everything!! Little Eden is like a secret jewel no one but yourself and your
                    very best friends should know about, but at the same time it’s like discovering
                    something so awesome you can never keep it to yourself. You have to tell the
                    world!!!
                  </p>
                  <h5>Sisna & Andries Venter</h5>
                  <p>- on visiting Little Eden</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </carousel>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  }
};
</script>

<style lang="scss" scoped></style>
